import DIApi from './_diApi';

class TempFixedAssetCategoryAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'TempFixedAssetCategorys';
}

export default new TempFixedAssetCategoryAPI();
